const OVER_FAMILY = Object.freeze(["MEGA SMASH", "SMASH", "LEAN OVER", "COIN TOSS"]);
const UNDER_FAMILY = Object.freeze(["MEGA FADE", "FADE", "LEAN UNDER", "COIN TOSS"]);

export const recommendationTagsForDirection = (allTags, direction) => {
  const family = direction === "OVER" ? OVER_FAMILY : direction === "UNDER" ? UNDER_FAMILY : allTags;
  return allTags.filter((tag) => family.includes(tag));
};

export const directionPreset = (direction) => ({
  direction,
  selectedTags: direction === "OVER" ? [...OVER_FAMILY] : direction === "UNDER" ? [...UNDER_FAMILY] : [],
});

export const toggleDirectionPreset = (currentDirection, requestedDirection) =>
  directionPreset(currentDirection === requestedDirection ? "ALL" : requestedDirection);

export const toggleCompatibleRecommendation = (selectedTags, tag, direction) => {
  const compatible = recommendationTagsForDirection(
    ["MEGA SMASH", "SMASH", "LEAN OVER", "MEGA FADE", "FADE", "LEAN UNDER", "COIN TOSS"],
    direction
  );
  if (!compatible.includes(tag)) return selectedTags;
  return selectedTags.includes(tag) ? selectedTags.filter((item) => item !== tag) : [...selectedTags, tag];
};
